/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { resetForm } from '@insticator/insticator-ui';
import { discardChanges } from '@insticator/insticator-ui';
import { savePaymentInformationWithValidation, updatePaymentInformationWithValidation, getPaymentInformation } from 'state/actions/accountState/account_data';
import { displayModal } from '@insticator/insticator-ui'; // iui-state
// component
import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs';



/* ========== ~~~~~~~~~~ PAYMENT INFO CTAS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus, appStatus }) => ({
    fields: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].fields,
    savingData: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].savingData,
    editable: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].editable,
    hasStoredData: accountData.selectedPaymentType === 'NONE' ? null : Object.keys(accountData[accountData.selectedPaymentType].storedData).length > 0,
    formName: accountData.selectedPaymentType,
    paymentInfoReceived: accountData.paymentInfoReceived,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentInfo: accountData.paymentInfo,
    payoutThreshold: accountData.payoutThreshold,
    savedPaymentInfo: accountData.paymentInfo.length > 0,
    preferredPaymentUpdated: accountData.preferredPaymentUpdated,
    paymentUUID: accountData.paymentUUID,
    accountUUID: sessionStatus.accountUUID,
    paymentInfoPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.paymentInfo'),
    mocked: sessionStatus.mocked,
    permissions: sessionStatus.permissions,
    currentPage: appStatus.currentPage,
    previousPage: appStatus.previousPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    updatePaymentInformationWithValidation: ( data, paymentType, fields, paymentUUID, successAction ) => dispatch(updatePaymentInformationWithValidation(fields, data, paymentType, paymentUUID, successAction)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID, successAction ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID, successAction)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentInfoCTAs);
